'use client';

// module imports
import { useRouter } from 'next/navigation';

// file imports
import { OAuthButton, RegisterForm } from '@/components';
import { showSuccess } from '@/lib/toast';
interface RegisterCardProps {
  onOAuthClick: (provider: string) => void;
}

export default function RegisterCard({ onOAuthClick }: RegisterCardProps) {
  const router = useRouter();

  const handleRegisterSuccess = (email: string) => {
    showSuccess(
      <div>
        <div className="font-semibold">Registration Successful!</div>
        <div className="text-sm mt-1">
          We&apos;ve sent a verification link to <strong>{email}</strong>. Please check your inbox and click the link to activate your account.
        </div>
      </div>,
      {
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );

    // Redirect to login after a short delay
    setTimeout(() => {
      router.push('/login');
    }, 2000);
  };

  return (
    <div className="max-w-md w-full bg-white rounded-3xl shadow-lg p-10 flex flex-col items-center">
      <h1 className="text-2xl font-bold text-gray-800 mb-8">Create Account</h1>

      <RegisterForm onSuccess={handleRegisterSuccess} />

      <div className="flex items-center w-full my-6">
        <hr className="flex-grow border-gray-300" />
        <span className="mx-4 text-gray-400 font-semibold">OR</span>
        <hr className="flex-grow border-gray-300" />
      </div>

      <button className="w-full py-3 bg-[#e92773] text-white font-bold rounded-lg hover:bg-[#c51c5b] cursor-pointer transition" onClick={() => router.push('/login')} type="button">
        Already have an account? Login
      </button>

      <OAuthButton provider="google" onClick={() => onOAuthClick('google')}>
        Continue with Google
      </OAuthButton>

      <OAuthButton provider="linkedin" onClick={() => onOAuthClick('linkedin')}>
        Continue with LinkedIn
      </OAuthButton>
    </div>
  );
}
